var map = {
	"./adult/nn/2 5 Ordkjedetest-Riktig.mp3": 600,
	"./adult/no/2 5 Ordkjedetest-Riktig.mp3": 601,
	"./youth/de/2 5 Ordkjedetest-Riktig.mp3": 602,
	"./youth/nn/2 5 Ordkjedetest-Riktig.mp3": 603,
	"./youth/no/2 5 Ordkjedetest-Riktig.mp3": 604,
	"./youth/se/2 5 Ordkjedetest-Riktig.mp3": 605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 599;